// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"850fa7fb","122":"5ac3db81","237":"60e5f046"}[chunkId] + ".chunk.js";
};